export interface ShopifyProductSourceFieldOption {
  path: string;
  label: string;
}

/** Shopify fields allowed for product matching. */
export const SHOPIFY_PRODUCT_SOURCE_FIELDS: ShopifyProductSourceFieldOption[] = [
  { path: 'variants.barcode', label: 'Variant barcode' },
  { path: 'variants.sku', label: 'Variant SKU' },
  { path: 'variants.id', label: 'Variant ID' },
];

export const JUSTSTOCK_PRODUCT_TARGET_FIELDS: ShopifyProductSourceFieldOption[] = [
  { path: 'ean', label: 'EAN' },
  { path: 'sku', label: 'SKU' },
];

export function customFieldTargetPath(key: string): string {
  return `customFields.${key}`;
}

export function customFieldTargetLabel(label: string): string {
  return label;
}

export function isCustomFieldTarget(path: string): boolean {
  return path.startsWith('customFields.');
}

export function customFieldKeyFromTarget(path: string): string | undefined {
  if (!isCustomFieldTarget(path)) return undefined;
  return path.slice('customFields.'.length);
}
